// extracted by mini-css-extract-plugin
module.exports = {"container":"Pagination_container__3U2Ea","pageDisplay":"Pagination_pageDisplay__3lStp"};